import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F6F4F0] flex items-center justify-center px-6 noise">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        data-testid="payment-cancel" className="max-w-lg text-center">
        <span className="overline text-[#B86B52]">Booking Not Completed</span>
        <h1 className="font-display font-light text-5xl text-[#1A1918] mt-6 mb-4">No worries</h1>
        <p className="text-[#5C5A56] font-light leading-relaxed">
          Your payment was cancelled and you have not been charged. Punto Nima is still available — try again whenever you're ready.
        </p>
        <Link to="/#booking" data-testid="retry-booking" className="inline-block mt-10 px-8 py-3.5 bg-[#B86B52] text-white rounded-sm tracking-wide hover:bg-[#a35c45] transition-colors">
          Return to Booking
        </Link>
      </motion.div>
    </div>
  );
}
